
import { Vue } from "vue-class-component";

export default class WarningTriangle extends Vue {}
